let count = 0;
let onComboChange = null;

function emit(nextCount) {
  if (typeof onComboChange === 'function') onComboChange(nextCount);
}

export const comboRuntime = {
  init(onComboChangeFn) {
    onComboChange = typeof onComboChangeFn === 'function' ? onComboChangeFn : null;
    count = 0;
    emit(0);
  },

  onKill() {
    count += 1;
    emit(count);
  },

  onHit() {
    if (count === 0) return;
    count = 0;
    emit(0);
  },

  onDeath() {
    count = 0;
    emit(0);
  },

  getCount() {
    return count;
  },
};
